import { connect } from 'react-redux';
import { getScreenData, resetStateReports } from '../actions/Actions';
import InvocadorReportes from './InvocadorReportes';

const mapStateToProps = ( state ) => {
    return {
        isFetching: state.invocadorReportes.isFetching,
        functions: state.invocadorReportes.functions,
        nombre: state.invocadorReportes.nombre,
        gruposReportes: state.invocadorReportes.reportes,
        login: state.sesion.executionContext.login,
        adUserGroup: state.sesion.adUserGroup
    }
}

const mapDispatchToProps = ( dispatch, ownProps ) => {
    return {
        getScreenData: ( currentScope, login, adUserGroup ) => {
            dispatch( getScreenData( currentScope, login, adUserGroup ) );
        },
        resetStateReports: () => {
            dispatch( resetStateReports() );
        }
    }
}

//Connect entre el componente y las props y actions.
const InvocadorReportesContainer = connect( mapStateToProps, mapDispatchToProps )( InvocadorReportes );

export default InvocadorReportesContainer;


// WEBPACK FOOTER //
// ./Portico/App/Screens/InvocadorReportes/components/Container.jsx